import React, { useEffect } from "react";
import { X } from "lucide-react";

const ROWS = [
  { size: "XS", chest: "38 / 96", waist: "30 / 76", length: "26 / 66" },
  { size: "S", chest: "40 / 101", waist: "32 / 81", length: "27 / 68" },
  { size: "M", chest: "42 / 106", waist: "34 / 86", length: "28 / 71" },
  { size: "L", chest: "44 / 111", waist: "36 / 91", length: "29 / 73" },
  { size: "XL", chest: "46 / 116", waist: "38 / 96", length: "30 / 76" },
  { size: "XXL", chest: "48 / 121", waist: "40 / 101", length: "31 / 78" },
];

export default function SizeGuideModal({ open, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="mt-modal-backdrop" onClick={onClose} data-testid="size-guide-modal-backdrop">
      <div
        className="mt-modal mt-rainbow-edge"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Size guide"
        data-testid="size-guide-modal"
        style={{
          background: "var(--mt-modal-bg, rgba(15,15,18,0.96))",
          backdropFilter: "blur(80px) saturate(200%)",
          WebkitBackdropFilter: "blur(80px) saturate(200%)",
          border: "1px solid var(--mt-glass-border)",
          boxShadow: "0 30px 80px -30px rgba(0,0,0,0.85), inset 0 1px 0 rgba(255,255,255,0.08)",
          color: "var(--mt-text)",
        }}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-display text-2xl font-light">Size Guide</h3>
            <p className="font-mono text-[0.62rem] tracking-mt uppercase mt-1" style={{ color: "var(--mt-text-muted)" }}>
              Chest · Waist · Length (inches / cm)
            </p>
          </div>
          <button onClick={onClose} className="mt-glass rounded-full p-2" aria-label="Close" data-testid="size-guide-close">
            <X size={16} />
          </button>
        </div>

        <table className="w-full mt-5 text-left border-separate" style={{ borderSpacing: 0 }}>
          <thead>
            <tr className="font-mono text-[0.6rem] tracking-mt uppercase opacity-60">
              <th className="py-3 pr-4">Size</th>
              <th className="py-3 pr-4">Chest</th>
              <th className="py-3 pr-4">Waist</th>
              <th className="py-3 pr-4">Length</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r, i) => (
              <tr
                key={r.size}
                style={{
                  background: i % 2 === 0 ? "rgba(255,255,255,0.03)" : "transparent",
                }}
              >
                <td className="py-3 pr-4 font-display text-lg">{r.size}</td>
                <td className="py-3 pr-4 font-mono text-[0.78rem]">{r.chest}</td>
                <td className="py-3 pr-4 font-mono text-[0.78rem]">{r.waist}</td>
                <td className="py-3 pr-4 font-mono text-[0.78rem]">{r.length}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="mt-5 italic text-xs" style={{ color: "var(--mt-text-muted)" }}>
          Sizes are a guide. Our pieces are cut with intentional oversize, so go down a size for a regular fit.
        </p>
      </div>
    </div>
  );
}
